/*
 * bladeからメッセージ取得用mixin
 */
<script>
export default {
    mixins: [
// ソートID管理用mixin
		 require('js/common/HtmlAnalyze.mixin.vue'),
		],
	data: function(){
		return{
			m_arrMsgDisp: {},				// 表示用メッセージ
		};
	},
	methods: {
		// 共通処理
		setMessages: function( messages ) {
			// 使用していないためコメントアウト
			// this.m_arrMsgDisp = JSON.parse( this.htmlEntities( messages, 'decode' ) );
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/SetMessages.mixin.vue